import { Component } from '@angular/core';
import { LoginService } from '../../../shared/services/login.service';
import { ThemeService } from '../../theme.service';

@Component({
  standalone: false,
  selector: 'ingsv-adm-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout windowMode
      [ngClass]="{
        'logged-in': loginService.isLoggedIn,
        'remove-animation': themeService.removeAnimation
      }">
      <nb-layout-header fixed class="header">
        <ingsv-adm-header></ingsv-adm-header>
      </nb-layout-header>

      <nb-layout-column
        class="animation-container"
        [ngClass]="{
          'remove-animation': themeService.removeAnimation
        }">
        <ng-content select="router-outlet"></ng-content>
        <ingsv-adm-footer></ingsv-adm-footer>
      </nb-layout-column>

    </nb-layout>
  `,
})
export class OneColumnLayoutComponent {
  constructor(
    public themeService: ThemeService,
    public loginService: LoginService
  ) {}
}
